module.exports = __webpack_public_path__ + "img/storeNum5.313692b4.png";